// actions
import ACTIONS from "../../../constants/actions";
import { LOCAL_STORAGE } from "../../../constants/localStorageConstants";
// others
import { AXIOS_INSTANCE } from "../../../config.js";

const { AUTHORITIES, SELECTED_BRANCH } = LOCAL_STORAGE;

const {
  GET_AUTHORITIES_REQUEST,
  GET_AUTHORITIES_FAIL,
  GET_AUTHORITIES_SUCCESS,
} = ACTIONS;

export function requestGetAuthorities() {
  return (dispatch) => {
    dispatch({
      type: GET_AUTHORITIES_REQUEST,
    });
    return AXIOS_INSTANCE.request({
      url: `/api/${
        JSON.parse(localStorage.getItem(SELECTED_BRANCH))["code"]
      }/authorities/token`,
      method: "GET",
    })
      .then((res) => {
        localStorage.setItem(AUTHORITIES, JSON.stringify(res.data));
        dispatch({
          type: GET_AUTHORITIES_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_AUTHORITIES_FAIL,
        });
      });
  };
}
